import { CloseOutlined, WarningOutlined } from '@ant-design/icons';
import { Modal, Title, Text, Button, Table } from '@bancobarigui/barihaus';

import { DuplicateInspection } from '@/services/types/inspection.types';

interface DuplicateLocationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
  duplicateInspections: DuplicateInspection[];
  currentAddress: string;
}

export function DuplicateLocationModal({
  open,
  onClose,
  onConfirm,
  onCancel,
  duplicateInspections,
  currentAddress,
}: DuplicateLocationModalProps) {
  const formatDate = (dateString: string) => {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('pt-BR');
  };

  const columns = [
    {
      title: 'Proposta',
      dataIndex: 'proposalNumber',
      key: 'proposalNumber',
      render: (value: string) => value || '-',
    },
    {
      title: 'Endereço',
      dataIndex: 'address',
      key: 'address',
    },
    {
      title: 'Status',
      dataIndex: 'statusDescription',
      key: 'statusDescription',
    },
    {
      title: 'Data Criação',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (value: string) => formatDate(value),
    },
  ];

  return (
    <Modal
      centered
      open={open}
      width={800}
      footer={null}
      onCancel={onClose}
      className="space-y-8"
      closeIcon={<CloseOutlined />}
    >
      <div className="flex items-center gap-3 mb-6">
        <WarningOutlined className="text-3xl text-yellow-500" />
        <Title level={3} className="!mb-0">
          Localização já inspecionada
        </Title>
      </div>

      <div className="mb-4">
        <Text>
          O endereço <Text strong>{currentAddress}</Text> já possui inspeção cadastrada.
        </Text>
      </div>

      <div className="mb-4">
        <Text type="secondary">
          Foram encontradas as seguintes inspeções com esta localização:
        </Text>
      </div>

      <Table
        dataSource={duplicateInspections}
        columns={columns}
        rowKey="inspectionItemId"
        pagination={false}
        size="small"
        className="mb-6"
      />

      <div className="mb-6">
        <Text strong>Deseja continuar mesmo assim?</Text>
      </div>

      <div className="flex justify-end gap-3">
        <Button onClick={onCancel}>Não</Button>
        <Button buttonColor="primary" onClick={onConfirm}>
          Sim
        </Button>
      </div>
    </Modal>
  );
}
